import { createContext, useContext } from "react";
import { ITypesCharacteristicsContext } from "./types";

export const TypesCharacteristicsContext = createContext<ITypesCharacteristicsContext | null>(null);

export const useTypesCharacteristicsContext = () => {
  const context = useContext(TypesCharacteristicsContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
